import { z } from "zod/v4";

import { CustomEventDtoSchema } from "../dtos/analytics-events/custom-events";
import { CreateExperienceCustomMetricDtoSchema } from "../dtos/experience-custom-metrics";
import { CreateExperienceKeyMetricDtoSchema } from "../dtos/experience-key-metrics";

export const CreateExperienceCustomMetricFeSchema =
  CreateExperienceCustomMetricDtoSchema.extend({
    customEvent: CustomEventDtoSchema,
  });
export type CreateExperienceCustomMetricFe = z.infer<
  typeof CreateExperienceCustomMetricFeSchema
>;

// // key metric w enriched custom metric
export const ExperienceKeyMetricFeSchema =
  CreateExperienceKeyMetricDtoSchema.extend({
    experienceCustomMetric: CreateExperienceCustomMetricFeSchema.optional(),
  });

export type ExperienceKeyMetricFe = z.infer<typeof ExperienceKeyMetricFeSchema>;
